import React, { useRef } from "react";
import { Tab, Tabs, Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";

import { useSelector } from "react-redux";

import PIWILmRNA from "./PIWILmRNA";
import PIWILProteinExpression from "./PIWILProteinExpression";
import DFIDataSCDKit from "./DFIDataSCDKit";
import CometAssay from "./CometAssay";
import OxidativeStressData from "./OxidativeStressData";
import YMicroDeletion from "./YMicroDeletion";
import TelomereLength from "./TelomereLength";
import { decryptId } from "../../utils/helpers";


function MolecularProfile() {
    const tabsStyle = {
        display: "flex",
        justifyContent: "left",
        gap: "5px",
        marginTop: "18px",
        marginBottom: "8px", fontSize: "12px",
        borderBottom: "1px solid #a6a680ff",
    };
    const sampleCode = useSelector((state) => state.sample.code);




    const tabContentStyle = {
        padding: "10px",
        minHeight: "30vh",
    };



    const { sample_id } = useParams();

    const decodedId = decodeURIComponent(sample_id);
    const id = decryptId(decodedId);
    const alertShown = useRef(false);
    return (
        <div className="text-center" style={{ position: "relative", minHeight: "80vh" }}>

            <div
                className="d-flex align-items-center justify-content-between"

            >
                {/* Label */}
                <p className="mb-0 fw-bold">Molecular Profile</p>
                <div className="floating-label">
                    {sampleCode}
                </div>

                {/* Buttons */}
                <div className="d-flex gap-3">
                    <Link
                        to={`/clinical-profile/${encodeURIComponent(sample_id)}`}
                        className="text-decoration-none"
                    >
                        <Button variant="warning" style={{ fontWeight: 600 }} size="sm">
                            Clinical Profile
                        </Button>
                    </Link>

                    <Link
                        to={`/Update_Male_Details/${encodeURIComponent(sample_id)}`}
                        className="text-decoration-none"
                    >
                        <Button variant="warning" style={{ fontWeight: 600 }} size="sm">
                            Partner Details
                        </Button>
                    </Link>

                </div>
            </div>


            <Tabs defaultActiveKey="piwil-mrna" id="molecular-profile-tabs" className="mb-3" style={tabsStyle}>
                <Tab
                    eventKey="piwil-mrna"
                    title="PIWIL mRNA expression"
                >
                    <div style={tabContentStyle}>
                        <PIWILmRNA />
                    </div>
                </Tab>

                <Tab
                    eventKey="piwil-protein-expression"
                    title="PIWIL Protein expression"
                >
                    <div style={tabContentStyle}>
                        <PIWILProteinExpression />
                    </div>
                </Tab>

                <Tab
                    eventKey="dfi-data-scd-kit"
                    title="DFI data – SCD kit"
                >
                    <div style={tabContentStyle}>
                        <DFIDataSCDKit />
                    </div>
                </Tab>

                <Tab
                    eventKey="comet-assay"
                    title="DFI data – COMET assay"
                >
                    <div style={tabContentStyle}>
                        <CometAssay />
                    </div>
                </Tab>

                <Tab
                    eventKey="oxidative-stress-data"
                    title="Oxidative stress data"
                >
                    <div style={tabContentStyle}>
                        <OxidativeStressData />
                    </div>
                </Tab>

                <Tab
                    eventKey="y-microdeletion"
                    title="Y-microdeletion data"
                >
                    <div style={tabContentStyle}>
                        <YMicroDeletion />
                    </div>
                </Tab>
                <Tab
                    eventKey="TelomereLength"
                    title="Telomere length"
                >
                    <div style={tabContentStyle}>
                        <TelomereLength />
                    </div>
                </Tab>
            </Tabs>


            <style>{`
       
                    .floating-label {
                    position: fixed;
                    top: 50%;
                    left: 1px;
                    transform: translateY(-50%);

                    background: linear-gradient(
                        180deg,
                        #ff5C4D   /* soft medical blue */ 
                        
                    ); 

                    color: #3333BB;
                    font-family: "Poppins", "Montserrat", "Segoe UI", sans-serif;
                    padding: 14px 16px;
                    border-radius: 10px;

                    box-shadow:
                        0 10px 25px rgba(30, 64, 175, 0.35),
                        inset 0 1px 0 rgba(255, 255, 255, 0.25);

                    z-index: 1000;

                    writing-mode: vertical-rl;
                    text-orientation: mixed;

                    font-size: 14px;
                    font-weight: 700;
                    letter-spacing: 1px;

                    backdrop-filter: blur(4px);
                    }

      `}</style>
        </div>
    );
}

export default MolecularProfile;
